'use client';

import {Box, styled, Theme} from '@mui/material';
import {Link} from '@/i18n/navigation';

const richTextLinkStyles = ({theme, useSecondaryLinkColor}: {theme: Theme; useSecondaryLinkColor?: boolean}) => ({
  color: useSecondaryLinkColor ? theme.palette.text.linkSecondary : theme.palette.text.link,
  textDecoration: 'none',
  transition: 'color 150ms ease, text-underline-offset 150ms ease, text-decoration-thickness 150ms ease',
  '&:hover': {
    textDecoration: 'underline',
    textUnderlineOffset: theme.spacing(0.3),
    textDecorationThickness: '1.5px',
  },
});

export const StyledRichTextLink = styled('a', {
  shouldForwardProp: (prop) => prop !== 'useSecondaryLinkColor',
})<{ useSecondaryLinkColor?: boolean }>(richTextLinkStyles);

export const StyledRichTextInternalLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'useSecondaryLinkColor',
})<{ useSecondaryLinkColor?: boolean }>(richTextLinkStyles);

export const StyledRichTextTableWrapper = styled('div')(({theme}) => ({
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  minWidth: 0,
  maxWidth: 'calc(100vw - 48px)',
  marginBottom: theme.spacing(3),
  borderRadius: theme.shape.borderRadiusMd,
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.dark,
  backgroundColor: theme.palette.background.grey,
  padding: theme.spacing(2.5, 1.5),
  '& table': {
    borderCollapse: 'collapse',
    minWidth: 500,
    width: '100%',
  },
  '& th, & td': {
    padding: theme.spacing(0, 1.5),
    textAlign: 'left',
    fontSize: theme.typography.body2.fontSize,
    verticalAlign: 'top',
  },
  '& th': {
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
}));

export const StyledRichTextMediaContainer = styled(Box)(({theme}) => ({
  borderRadius: theme.shape.borderRadiusLg,
  margin: theme.spacing(3, 0),
  position: 'relative',
  overflow: 'hidden',
}));

export const StyledRichTextCtaArea = styled(Box)(({theme}) => ({
  background: theme.palette.background.grey,
  color: theme.palette.text.dark,
  padding: theme.spacing(6, 3),
  margin: theme.spacing(6, 0),
  borderRadius: theme.shape.borderRadiusLg,
}));
